/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

import { reactive } from 'vue'

const modals = reactive([])

function open(component, props = {}, options = {}) {
    const id = Date.now() + Math.random()

    modals.push({
        id,
        component,
        props,
        options
    })

    return id
}

function close(id) {
    const index = modals.findIndex(m => m.id === id)
    if (index !== -1) modals.splice(index, 1)
}

function closeAll() {
    modals.splice(0)
}

export function useModal() {
    return { modals, open, close, closeAll }
}